import EmblaCarousel from 'embla-carousel';
const selectors = {
    editorialProductCarousel: '[data-editorial-product-carousel]',
    editorialProductCarouselViewport: '[data-editorial-product-carousel-viewport]',
    editorialProductCarouselPrev: '[data-editorial-product-carousel-prev]',
    editorialProductCarouselNext: '[data-editorial-product-carousel-next]',
};
const classes = {
    hoverLeft: 'embla__viewport--hover-left',
    hoverRight: 'embla__viewport--hover-right',
};
const editorialProductCarousel = () => {
    const editorialProductCarousels = document.querySelectorAll(selectors.editorialProductCarousel);
    if (editorialProductCarousels) {
        editorialProductCarousels.forEach((carousel) => {
            const viewportNode = carousel.querySelector(selectors.editorialProductCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.editorialProductCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.editorialProductCarouselNext);
            const options = {
                loop: true,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options);
            prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
            nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
            let viewportNodeHalfWidth = viewportNode.offsetWidth / 2, viewportNodeBounding = viewportNode.getBoundingClientRect(), viewportLeft = viewportNodeBounding.left, viewportRight = viewportNodeBounding.right;
            window.addEventListener('resize', () => {
                viewportNodeHalfWidth = viewportNode.offsetWidth / 2;
                viewportNodeBounding = viewportNode.getBoundingClientRect();
                viewportLeft = viewportNodeBounding.left;
                viewportRight = viewportNodeBounding.right;
            });
            viewportNode.addEventListener('mousemove', (e) => {
                viewportNode.classList.remove(classes.hoverRight);
                viewportNode.classList.remove(classes.hoverLeft);
                if (e.clientX > viewportLeft && e.clientX < viewportLeft + viewportNodeHalfWidth) {
                    viewportNode.classList.add(classes.hoverLeft);
                }
                if (e.clientX > viewportLeft + viewportNodeHalfWidth && e.clientX < viewportRight) {
                    viewportNode.classList.add(classes.hoverRight);
                }
            });
            viewportNode.addEventListener('mouseleave', () => {
                viewportNode.classList.remove(classes.hoverLeft);
                viewportNode.classList.remove(classes.hoverRight);
            });
        });
    }
};
export { editorialProductCarousel };
